import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import SettingDetail from './components/SettingDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageSetting',
  components: {
    SettingDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;